import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDia } from "./TextDia";
import { SourcesDia } from "./SourcesDia";

export default function Dia() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};
    
return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Other Diabetes Genes' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Other Diabetes Genes - Variants'

        content={<TextDia />}

        sources={<SourcesDia />}

/>

</>
)}